import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

export const CompareGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 40px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
`;

export const GroupTitle = styled(Text.P1Bold)`
  color: ${colours.neutral[900]};
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colours.neutral[100]};
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 8px 0;
`;

export const RowLabel = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  min-width: 0;
`;

export const RowLabelIcon = styled.span<{ $color: string }>`
  align-items: center;
  color: ${({ $color }) => $color};
  display: flex;
  flex-shrink: 0;

  svg {
    height: 16px;
    width: 16px;
  }
`;

export const RowLabelText = styled(Text.P1)`
  color: ${colours.neutral[900]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowValues = styled.div`
  align-items: baseline;
  display: flex;
  flex-shrink: 0;
  gap: 10px;
`;

export const RowCount = styled(Text.P1)`
  color: ${colours.neutral[500]};
`;

export const RowValue = styled(Text.P1Bold)`
  color: ${colours.neutral[900]};
`;

export const ShowMoreRow = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
  width: 100%;
`;
